import { Link } from "react-router-dom";
import { SrIcon } from "@/components/ui/SrIcon";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { channelKey } from "@/lib/chat-room/channels";
import { cn } from "@/lib/utils";

/**
 * «Åpne i Chat» på Prosjektoppdateringer (VIB-3024). Prosjektkanalen i
 * Chat-rommet er samme strøm, så lenken åpner bare samme samtale i Chat.
 * Vises bare når flagget feature_chat_rom er på for brukeren.
 */
export function OpenInChatLink({ projectId, className }: { projectId: string; className?: string }) {
  const enabled = useFeatureFlag("feature_chat_rom");
  if (!enabled) return null;
  return (
    <Link
      to={`/chat?kanal=${encodeURIComponent(channelKey("project", projectId))}`}
      onClick={(e) => e.stopPropagation()}
      className={cn(
        "inline-flex h-8 items-center gap-1.5 rounded-md border-[1.5px] border-[var(--sr-revemoerk)] px-2.5 text-xs font-medium text-foreground hover:bg-secondary",
        className,
      )}
    >
      <SrIcon name="message-square" className="h-3.5 w-3.5" />
      Åpne i Chat
    </Link>
  );
}
